module.exports = __webpack_public_path__ + "static/media/12.3f67b8c7.PNG";